export const EDUCATION = [
  {
    value: 'Bachelors Degree',
    label: 'Bachelors Degree',
  },
  {
    value: 'Masters Degree',
    label: 'Masters Degree',
  },
  {
    value: 'Ph.D/Doctorate',
    label: 'Ph.D/Doctorate',
  },
  {
    value: 'Medical Degree',
    label: 'Medical Degree',
  },
  {
    value: 'Law Degree',
    label: 'Law Degree',
  },
  {
    value: 'No High School Diploma',
    label: 'No High School Diploma',
  },
  {
    value: 'High School Diploma',
    label: 'High School Diploma',
  },
  {
    value: 'Associates Degree',
    label: 'Associates Degree',
  },
  {
    value: 'Some College - No Degree',
    label: 'Some College - No Degree',
  },
  {
    value: 'Vocational/Technical Degree',
    label: 'Vocational/Technical Degree',
  },
];
